import "./App.css";
import { BrowserRouter, Routes, Route, Navigate  } from "react-router-dom"; 
import DeleteAccountPage from "./screens/DeleteAccountPage";
import HomeScreen from "./screens/HomeScreen";
import Login from "./screens/Login";
import PrivacyPolicy from "./screens/PrivacyPolicy";
import {auth} from "./firebase"

function App() {
    //prüft, ob der User eigeloggtist. Wenn nein bleibt man auf der login Seite
    const RequireAuth = ({ children }) => {
      return auth.currentUser?.email ? (children) : <Navigate to="/login" />;
    };
  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
      <Route index element={<HomeScreen />} />
      <Route path="/deleteMyAccount" element={<RequireAuth><DeleteAccountPage/></RequireAuth>} />
      <Route path="/login" element={<Login/>} />
      <Route path="/policy" element={<PrivacyPolicy/>} />
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
